import type { FeatureCollection, Geometry } from "geojson";

export const loadKml = async (file: File) => {
  let xml: string | undefined;
  if (file.name.endsWith(".kmz")) {
    const JSZip = await import("jszip");
    const zip = await JSZip.loadAsync(file);
    xml = await zip.file("doc.kml")?.async("string");
  } else if (file.name.endsWith(".kml")) xml = await file.text();
  if (!xml) return;

  if (!xml.includes("xmlns:xsRi"))
    xml = xml.replace(
      "<kml ",
      '<kml xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ',
    );

  const document = new DOMParser().parseFromString(xml, "text/xml");

  // Hack to make <gx:CascadingStyle /> work
  const fixStyles = (element: Element, id?: string) => {
    if (element.tagName === "gx:CascadingStyle")
      id = element.getAttribute("kml:id") ?? undefined;
    else if (id && element.tagName === "Style" && !element.hasAttribute("id"))
      element.setAttribute("id", id);
    for (const child of Array.from(element.children)) fixStyles(child, id);
  };

  const [root] = Array.from(document.children);
  if (!root) throw new Error("Invalid");

  fixStyles(root);

  const { kml } = await import("@tmcw/togeojson");

  return kml(document, { skipNullGeometry: true }) as
    FeatureCollection<Geometry> | undefined;
};
